module.exports = __webpack_public_path__ + "10a79b6fd12312a4acce2e846bfaf2d6.jpg";


//////////////////
// WEBPACK FOOTER
// ./images/head/zoomparty.jpg
// module id = 917
// module chunks = 0